import React from "react"

import { InfoSectionSupportSubscript } from "./SupportSubscript"

interface Props {
  children: React.ReactNode
}

export const InfoSectionStickyFooter = ({ children }: Props) => (
  <div
    data-testid="sticky-footer"
    className="sticky bottom-0 left-0 right-0 -mx-2 flex flex-col gap-12 border-t border-charcoal/20 bg-white pb-16 pt-12"
  >
    {children}
    <div className="hidden sm:block">
      <InfoSectionSupportSubscript />
    </div>
  </div>
)
